export const ITableColsRecentlyHome = [
	{
		title: "Members",
		key: "nickname",
	},
	{
		title: "Address",
		key: "walletAddress",
	},
	{
		title: "Amount",
		key: "coin",
		type: true,
		isWinLose: true,
		total: "difference=coinIn-coinOut",
	},
	{
		title: "Status",
		key: "status",
		isStatus: true,
		statusKey: "cash",
	},
	{
		title: "Remark",
		key: "remake",
	},
	{
		title: "Hash",
		key: "transNo",
		isCopy: true,
	},
	{
		title: "TimeZone",
		key: "zone",
	},
	{
		title: "Time",
		key: "createTime",
	},
];

export const ITableColsRecently = [
	{
		title: "Members",
		key: "nickname",
		underline: true, //显示下划线
		isNavigate: true,
		page: "/personnal-records",
		total: "Total",
	},
	{
		title: "Address",
		key: "walletAddress",
	},
	{
		title: "Amount",
		key: "coin",
		type: true,
		isWinLose: true,
		total: "difference=coinIn-coinOut",
	},
	{
		title: "Status",
		key: "status",
		isStatus: true,
		statusKey: "cash",
	},
	{
		title: "Remark",
		key: "remake",
	},
	{
		title: "Hash",
		key: "transNo",
		isCopy: true,
	},
	{
		title: "TimeZone",
		key: "zone",
	},
	{
		title: "Time",
		key: "createTime",
	},
];

export const ITableColsGameRecently = [
	{
		title: "Members",
		key: "nickname",
		underline: true, //显示下划线
		total: "Total",
	},
	{
		title: "OrderDetails",
		key: "orderId,refId",
		isCopy: true,
		multiplyLine: true,
	},
	{
		title: "Bet",
		key: "coin",
		isWinLose: true,
		total: "coinOut",
		settleCoinOut: true,
	},
	{
		title: "Reward",
		key: "rewardCoin",
		type: true,
		total: "coinIn",
	},
	{
		title: "WinLose",
		key: "rewardCoin",
		isWinLose: true,
		memoney: true,
		total: "difference=coinIn-settleCoinOut",
	},
	{
		title: "Commission",
		key: "commission",
	},
	{
		title: "ReturnWater",
		key: "returnWater",
	},
	{
		title: "Status",
		key: "status",
		isStatus: true,
		statusKey: "game",
	},
	{
		title: "TimeZone",
		key: "zone",
	},
	{
		title: "OrderTime",
		key: "createTime",
	},
	{
		title: "SettlementTime",
		key: "updateTime",
	},
];

export const ITableColsUserRecently = [
	{
		title: "Members",
		key: "nickname",
		underline: true, //显示下划线
		total: "Total",
	},
	{
		title: "OrderDetails",
		key: "orderId,refId",
		isCopy: true,
		multiplyLine: true,
	},
	{
		title: "Bet",
		key: "coin",
		isWinLose: true,
		total: "coinOut",
		settleCoinOut: true,
	},
	{
		title: "Reward",
		key: "rewardCoin",
		type: true,
		total: "coinIn",
	},
	{
		title: "WinLose",
		key: "rewardCoin,coin",
		isWinLose: true,
		memoney: true,
		total: "difference=coinIn-settleCoinOut",
	},
	{
		title: "Status",
		key: "status",
		isStatus: true,
		statusKey: "game",
	},
	{
		title: "TimeZone",
		key: "zone",
	},
	{
		title: "OrderTime",
		key: "createTime",
	},
	{
		title: "SettlementTime",
		key: "updateTime",
	},
];
// "createTime": "2024-05-02 12:11:16",
// "orderId": "1714623075269_REWARD",
// "uid": 2,
// "status": 3,
// "type": 1,
// "itemType": 1,
// "coin": 0,
// "walletAddress": "0x222"
export const ITableColsGameRecords = [
	{
		title: "Members",
		key: "nickname",
		// isNavigate: true,
		// page: '/'
	},
	{
		title: "Address",
		key: "walletAddress",
	},
	{
		title: "WinLose",
		key: "rewardCoin",
		isWinLose: true,
	},
	{
		title: "Status",
		key: "status",
		isStatus: true,
		statusKey: "game",
	},
	{
		title: "TimeZone",
		key: "zone",
	},
	{
		title: "Time",
		key: "createTime",
	},
];

export const ITableColsGameRecordsDetail = [
	{
		title: "Members",
		key: "nickname",
		underline: true, //显示下划线
		isNavigate: true,
		page: "/personnal-game-records",
		total: "Total",
	},
	{
		title: "OrderDetails",
		key: "transNo,refId",
		isCopy: true,
		multiplyLine: true,
	},
	{
		title: "Bet",
		key: "coin",
		isWinLose: true,
		total: "coinOut",
		settleCoinOut: true,
	},
	{
		title: "Reward",
		key: "rewardCoin",
		total: "coinIn",
	},
	{
		title: "Profit",
		key: "coin,rewardCoin",
		wlmoney: true,
		total: "difference=coinIn-settleCoinOut",
	},
	{
		title: "ReturnWater",
		key: "returnWater",
		total: "returnWater",
	},
	{
		title: "Commission",
		key: "commission",
		total: "commission",
	},
	{
		title: "MasterProfit",
		key: "agentPnl",
		memoney: true,
		total: "agentPnl",
	},
	{
		title: "Status",
		key: "status",
		isStatus: true,
		statusKey: "text",
	},
	{
		title: "TimeZone",
		key: "zone",
	},
	{
		title: "Time",
		key: "createTime",
	},
];

// 列改为1.Members（成员） 2.Details 游戏记录有-是订单号/充提是哈希值 3.Amount
// 4.Category（类别 - Deposit群主/管理员充值 Withdraw群主/管理员提款 Game-游戏记录 Comission-返佣记录）
// 5.状态 6.备注 7时区（GMT+9） 8时间
export const ITableColsDaicunRecordVault = [
	{
		title: "Members",
		key: "handlerNickname",
		underline: true, //显示下划线
		total: "Total",
	},
	{
		title: "Address",
		key: "handlerWalletAddress",
	},
	{
		title: "Amount",
		key: "coin",
		isWinLose: true,
		type: true,
		total: "difference=coinIn-coinOut",
	},
	// {
	// 	title: "Address",
	// 	key: "handlerWalletAddress",
	// },
	{
		title: "Active",
		key: "refName",
		isSrc: true,
	},
	{
		title: "Status",
		key: "status",
		isStatus: true,
		statusKey: "cash",
	},
	{
		title: "Remark",
		key: "remake",
	},
	{
		title: "Hash",
		key: "transNo",
		isCopy: true,
	},
	{
		title: "TimeZone",
		key: "zone",
	},
	{
		title: "Time",
		key: "createTime",
	},
];

export const ITableColsAdministrator = [
	{
		title: "Admin",
		key: "nickname",
		underline: true, //显示下划线
		total: "Total",
	},
	{
		title: "Address",
		key: "walletAddress",
	},
	{
		title: "Amount",
		key: "coin",
		isWinLose: true,
		type: true,
		total: "difference=coinIn-coinOut",
	},
	{
		title: "Active",
		key: "src",
		isSrc: true,
	},
	// {
	// 	title: "Balance",
	// 	key: "coin",
	// },
	{
		title: "Remark",
		key: "remake",
	},
	{
		title: "Status",
		key: "status",
		isStatus: true,
		statusKey: "cash",
	},
	{
		title: "Remark",
		key: "remake",
	},
	{
		title: "Hash",
		key: "transNo",
		isCopy: true,
	},
	{
		title: "TimeZone",
		key: "zone",
	},
	{
		title: "Time",
		key: "createTime",
	},
];

export const ITableColsRecordsGift = [
	{
		title: "Members",
		key: "nickname",
		underline: true, //显示下划线
	},
	{
		title: "PlayerAddress",
		key: "walletAddress",
	},
	{
		title: "AdminAddress",
		key: "handler",
	},
	{
		title: "Amount",
		key: "coin",
		isWinLose: true,
		type: true,
	},
	{
		title: "TimeZone",
		key: "zone",
	},
	{
		title: "Time",
		key: "createTime",
	},
];

export const ITableColsRewards = [
	{
		title: "Id",
		key: "id",
	},
	{
		title: "Members",
		key: "nickname",
	},
	{
		title: "PlayerAddress",
		key: "walletAddress",
		isCopy: true,
	},
	{
		title: "Amount",
		key: "coin",
		// isWinLose: true,
		// type: true,
	},
	{
		title: "Active",
		key: "src",
		isSrc: true,
	},
	// {
	// 	title: "Remake",
	// 	key: "remake",
	// },
	{
		title: "TimeZone",
		key: "zone",
	},
	{
		title: "Time",
		key: "updateTime",
	},
];
